const getContextPath = () => {
  return window.location.pathname.substring(0, window.location.pathname.indexOf("/", 1));
}

const isEmptyObject = (obj) => {
  for(let key in obj) {
    return false;
  }
  return true;
}

const hasOwnProperty = (obj, property) => {
  return Object.prototype.hasOwnProperty.call(obj, property)
}
const isMobile = () => {
	return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

const loadScript = (src, callback) => {
  var script = document.createElement('script'),
    head = document.getElementsByTagName('head')[0];
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.src = src;
  if (script.addEventListener) {
    script.addEventListener('load', function() {
      callback();
    }, false);
  } else if (script.attachEvent) {
    script.attachEvent('onreadystatechange', function() {
      var target = window.event.srcElement;
      if (target.readyState == 'loaded') {
        callback();
      }
    });
  }
  head.appendChild(script);
}

const _utf8_decode = (utftext) => {  
  var string = "";  
  var i = 0;  
  var c = 0;
  var c2 = 0;
  var c3 = 0;
  while (i < utftext.length) {
    c = utftext.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i++;
    } else if ((c > 191) && (c < 224)) {
      c2 = utftext.charCodeAt(i + 1);
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i + 1);
      c3 = utftext.charCodeAt(i + 2);
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      i += 3;
    }
  }
  return string;
}

const base64 = {
  decode: function(input){
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";  
    var output = "";  
    var chr1, chr2, chr3;  
    var enc1, enc2, enc3, enc4;  
    var i = 0;  
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");  
    while (i < input.length) {  
      enc1 = _keyStr.indexOf(input.charAt(i++));  
      enc2 = _keyStr.indexOf(input.charAt(i++));  
      enc3 = _keyStr.indexOf(input.charAt(i++));  
      enc4 = _keyStr.indexOf(input.charAt(i++));  
      chr1 = (enc1 << 2) | (enc2 >> 4);  
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);  
      chr3 = ((enc3 & 3) << 6) | enc4;  
      output = output + String.fromCharCode(chr1);  
      if (enc3 != 64) {  
          output = output + String.fromCharCode(chr2);  
      }  
      if (enc4 != 64) {  
          output = output + String.fromCharCode(chr3);  
      }  
    }  
    output = _utf8_decode(output);  
    return output;  
  }
}

const getElementsByTagName = (element, tagName) => {
  var nodeList = element.childNodes;
  var ary = [];
  if (/MSIE(6|7|8)/.test(navigator.userAgent)) {
    for (var i = 0; i < nodeList.length; i++) {
      var curNode = nodeList[i];
      if (curNode.nodeType === 1) {
        ary[ary.length] = curNode;
      }
    }
  } else {
    ary = Array.prototype.slice.call(element.children);
  }

  // 获取指定子元素
  if (typeof tagName === "string") {
    for (var k = 0; k < ary.length; k++) {
      var curTag = ary[k];
      if (curTag.nodeName.toLowerCase() !== tagName.toLowerCase()) {
        ary.splice(k, 1);
        k--;
      }
    }
  }

  return ary;
}

/**
 * @method serialize
 * @description 对请求参数序列化
 * @param {Object} data - 请求参数对象
 * return {String} data - 请求参数序列化结果
 */
const serialize = (data) => {
  if (!data) return '';
  let pairs = [], value;
  for (let name in data) {
    if (!Object.prototype.hasOwnProperty.call(data, name)) continue;
    if (typeof data[name] === 'function') continue;
    value = String(data[name]);
    name = encodeURIComponent(name);
    value = encodeURIComponent(value);
    pairs.push(name + '=' + value);
  }
  if (pairs.length) {
    return pairs.join('&');
  } else {
    return ''
  }
}

const isDef = function(v) {
  return v !== undefined && v !== null
}

const _toString = Object.prototype.toString
const isPlainObject = (obj) => {
  return _toString.call(obj) === '[object Object]'
}

const toString = (val) => {
  return val == null ?
    '' :
    typeof val === 'object' ?
    JSON.stringify(val) :
    String(val)
}
const S4 = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

const NewGuid = () => {
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4());
}

const Time = () => {
  return new Date().getTime()
}

const ToBoolean = (key) => {
  return key === 'false' ? false : !!key
}

// 这里对18位不做严格判断
const encode18bit = (id) => {
  if(!id) return
  if(typeof id === 'number') id = id.toString();
  if(/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/.test(id)) {
    id = id.replace(/(\w{6})(\w{8})(.*)/, '$1********$3');
  }
  return id
}

export {
  getContextPath, isEmptyObject, hasOwnProperty, isMobile, loadScript, base64,
  getElementsByTagName, serialize, isDef, isPlainObject, toString, NewGuid, Time, ToBoolean,
  encode18bit
}
